const uk = {
  code: 'uk',
  short: 'UA',
  label: 'Українська',
  native: 'Українська',
  hero: {
    badge: 'Клінінгові послуги • Одеса',
    title: 'Перлина чистоти.',
    lead: 'Прибирання квартир і просторів в Одесі.',
    whatsapp: 'WhatsApp'
  },
  header: {
    home: 'Головна',
    services: 'Послуги',
    contact: 'Контакти',
    whatsapp: 'WhatsApp',
    language: 'Мова'
  },
  home: {
    serviceNote: 'Pearl clean • Одеса • Чистота для вашого простору',
    servicesTitle: 'Наші послуги',
    seeDetails: 'Деталі →',
    whyTitle: 'Чому Pearl clean?',
    reasons: [
      'Послуги для квартир, офісів і комерційних приміщень',
      'Зв’язок у WhatsApp цілодобово',
      'Графік, склад робіт і деталі узгоджуються індивідуально',
      'Ціни для основних видів прибирання'
    ],
    areaTitle: 'Покриття',
    areaCopy: 'Одеса та околиці.',
    quote: 'Отримати пропозицію'
  },
  optional: 'необов’язково',
  servicesPage: {
    title: 'Послуги',
    subtitle: 'Натисніть на картку, щоб побачити повний перелік робіт, галерею та цінові примітки.'
  },
  notFound: {
    message: 'Сторінку не знайдено.',
    back: 'На головну'
  },
  serviceDetail: {
    notFound: 'Послугу не знайдено',
    back: 'Назад до послуг',
    priceLabel: 'Вартість',
    priceList: 'Прайс-лист',
    allServices: 'Усі послуги'
  },
  contact: {
    title: 'Контакти',
    hours: 'Відповідаємо цілодобово.',
    phoneLabel: 'Телефон',
    locationLabel: 'Локація',
    whatsapp: 'Написати у WhatsApp',
    office: 'Одеса'
  },
  footer: {
    tagline: 'Клінінгові послуги в Одесі для дому та бізнесу.',
    rights: 'Усі права захищені.',
    getInTouch: 'Зв’язатися',
    chat: 'Написати у WhatsApp'
  },
  whatsapp: {
    message: 'Вітаю! Хочу дізнатися більше про послуги Pearl clean в Одесі.'
  },
  services: [
    {
      slug: 'regular-cleaning',
      title: 'Базове прибирання',
      short: 'Основне прибирання для підтримання чистоти у квартирі чи офісі.',
      intro: 'Базове прибирання допомагає швидко привести простір до охайного стану.',
      description: [
        'Ми ретельно пилососимо та миємо всі доступні площі, обережно витираємо пил і чистимо кухню та ванну – дім залишається свіжим і доглянутим.',
        'Рекомендована частота: щотижня, раз на два тижні або щомісяця.'
      ],
      bullets: [
        'Пилососіння та миття підлог',
        'Витирання пилу з доступних поверхонь',
        'Дезінфекція кухні та санвузла',
        'Винесення сміття та заміна пакетів'
      ],
      priceNote: 'від 60 грн/м²'
    },
    {
      slug: 'general-cleaning',
      title: 'Генеральне прибирання',
      short: 'Баланс між регулярним та глибоким очищенням.',
      intro: 'Детальніше прибирання, ніж звичайна підтримка.',
      description: [
        'Включає всі етапи регулярного прибирання плюс ретельний догляд за кухнею та ванною, зовнішні поверхні техніки, внутрішнє очищення духовки й холодильника, а також догляд за зонами домашніх тварин.',
        'Рекомендована частота: щотижня, кожні два тижні або раз на місяць.'
      ],
      bullets: [
        'Чекліст регулярного прибирання включено',
        'Деталізація кухні та ванної',
        'Очищення духовки та холодильника всередині',
        'Видалення шерсті та прибирання зон тварин (місце годування, лоток)'
      ],
      priceNote: 'від 85 грн/м²'
    },
    {
      slug: 'deep-cleaning',
      title: 'Глибоке прибирання',
      short: 'Повне очищення зверху донизу для максимальної свіжості.',
      intro: 'Найдетальніша послуга з фокусом на важкодоступні зони та техніку.',
      description: [
        'Містить кожен крок генерального прибирання, плюс миття вікон зсередини та зовні (де дістати), внутрішнє очищення шаф і глибоку обробку техніки – холодильник, духовка, мікрохвильовка.',
        'За запитом – чищення меблів, килимів та балкона. Рекомендовано, коли потрібне повне оновлення простору.'
      ],
      bullets: [
        'Видалення накипу та жиру',
        'Очищення шаф та гардеробів всередині',
        'Вікна зсередини та зовні (доступні)',
        'Глибоке чищення побутової техніки'
      ],
      priceNote: 'від 95 грн/м²'
    },
    {
      slug: 'upholstery-cleaning',
      title: 'Хімчистка меблів',
      short: 'Професійне очищення м’яких меблів, матраців і килимів.',
      intro: 'Повертаємо свіжість меблям і текстилю з індивідуальним розрахунком за кожну позицію.',
      description: ['Оберіть потрібні позиції з прайсу.'],
      priceNote: 'Ціни вказані за одиницю, якщо не зазначено інше.',
      priceItems: [
        { id: 'two-seat-sofa', title: 'Диван 2-місний', price: 'від 1 000 грн' },
        { id: 'three-seat-sofa', title: 'Диван 3-місний', price: 'від 1 300 грн' },
        { id: 'large-straight-sofa', title: 'Великий прямий диван', price: 'від 1 500 грн' },
        { id: 'corner-sofa', title: 'Кутовий диван', price: 'від 1 500 грн' },
        { id: 'large-corner-sofa', title: 'Великий кутовий диван', price: 'від 1 800 грн' },
        { id: 'armchair', title: 'Крісло', price: 'від 400 грн' },
        { id: 'pouf', title: 'Пуф', price: 'від 250 грн' },
        { id: 'backless-chair', title: 'Стілець без спинки', price: 'від 120 грн' },
        { id: 'chair-with-back', title: 'Стілець зі спинкою', price: 'від 180 грн' },
        { id: 'sofa-pillow', title: 'Диванна подушка', price: 'від 100 грн' },
        { id: 'single-mattress', title: 'Матрац односпальний', price: 'від 800 грн' },
        { id: 'double-mattress', title: 'Матрац двоспальний', price: 'від 1 100 грн' },
        { id: 'carpet', title: 'Килим / ковролін', price: 'від 70 грн/м²' }
      ]
    },
    {
      slug: 'post-construction-cleaning',
      title: 'Прибирання після ремонту',
      short: 'Видалення пилу, фарби та сміття після будівництва.',
      intro: 'Професійне очищення після ремонту чи будівельних робіт.',
      description: [
        'Прибираємо пил, клей, фарбу та сміття, миємо вікна, підлоги, поверхні та ванні кімнати, щоб простір був готовий до заселення – чистий і без пилу.'
      ],
      bullets: [
        'Прибирання будівельного пилу та залишків',
        'Детальне очищення фурнітури, розеток та вимикачів',
        'Миття вікон, рам і підвіконь',
        'Фінальне полірування підлог і поверхонь'
      ],
      priceNote: 'від ₴___'
    },
    {
      slug: 'move-in-move-out',
      title: 'Прибирання при переїзді',
      short: 'Ідеально для нового старту чи здачі житла.',
      intro: 'Детальне прибирання для бездоганної передачі або заселення.',
      description: [
        'Звертаємо увагу на шафи, техніку, плінтуси та фурнітуру, щоб оселя була бездоганною для власника чи нових мешканців.',
        'Чудово перед фотографіями, перевірками чи заселенням.'
      ],
      bullets: [
        'Шафи та шухляди очищені всередині',
        'Дегресування техніки всередині',
        'Протерті вікна та рами',
        'Увага до деталей: плінтуси, вимикачі'
      ],
      priceNote: 'від ₴___'
    },
    {
      slug: 'office-cleaning',
      title: 'Прибирання офісів',
      short: 'Підтримуйте робочий простір бездоганним.',
      intro: 'Охайний і організований офіс завдяки професійній команді.',
      description: [
        'Глибоко очищаємо всі зони – від робочих місць і переговорних до кухонь та санвузлів – створюємо чисте і гігієнічне середовище.',
        'Досвідчена команда працює точно й непомітно, підтримує професійний імідж і комфортну атмосферу для співробітників та клієнтів.'
      ],
      bullets: [
        'Робочі зони, переговорні, ресепшен',
        'Дезінфекція кухонь і санвузлів',
        'Винесення сміття та сортування',
        'Гнучкий графік поза робочим часом'
      ],
      priceNote: 'від ₴___'
    },
    {
      slug: 'commercial-cleaning',
      title: 'Комерційне прибирання',
      short: 'Професійний сервіс для ресторанів, готелів та магазинів.',
      intro: 'Створіть бездоганний простір для гостей та команди.',
      description: [
        'Надаємо якісне прибирання для ресторанів, готелів, магазинів, салонів, фітнес-центрів та офісів, щоб кожна зона була чистою й гігієнічною.',
        'Увага до деталей – блискучі підлоги та меблі, продезінфіковані кухні та санвузли. Використовуємо екологічні засоби та надійні методи для безпеки й комфорту.',
        'Пропонуємо гнучкі графіки та персоналізовані плани під ваш режим роботи, щоб мінімізувати перерви.'
      ],
      bullets: [
        'Гостьові зони, бек-офіс і склади',
        'Дезінфекція зон дотику',
        'Догляд за твердими підлогами та килимами',
        'Плани під кожен тип бізнесу'
      ],
      priceNote: 'від ₴___'
    },
    {
      slug: 'window-cleaning',
      title: 'Миття вікон',
      short: 'Кришталево чисті вікна зсередини та зовні.',
      intro: 'Прозорі вікна наповнюють простір світлом.',
      description: [
        'Професійно миємо вікна в квартирах, офісах і комерційних приміщеннях – зсередини та зовні (доступні ділянки).',
        'Використовуємо екологічні засоби без розводів; скло блищить, рами чисті. Регулярне миття покращує освітлення та вигляд простору.'
      ],
      bullets: [
        'Внутрішні та доступні зовнішні стекла',
        'Протирка рам, підвіконь і напрямних',
        'Екологічні засоби без розводів',
        'Ідеально для дому, офісу та вітрин'
      ],
      priceNote: 'від ₴___'
    },
    {
      slug: 'carpet-upholstery-cleaning',
      title: 'Чистка килимів і м’яких меблів',
      short: 'Глибоке очищення та оновлення килимів і оббивки.',
      intro: 'Повертаємо м’якість і прибираємо запахи.',
      description: [
        'Видаляємо плями, алергени та накопичення професійною технікою, підібраною до тканини, тож текстиль знову свіжий.',
        'Ідеально як доповнення до глибокого прибирання або самостійне оновлення для завантажених зон.'
      ],
      bullets: [
        'Гаряча екстракція або маловолога методика',
        'Прицільне видалення плям і запахів',
        'Безпечні рішення для делікатних тканин',
        'Швидке висихання для мінімальних пауз'
      ],
      priceNote: 'від ₴___'
    }
  ]
};

export default uk;
